import React from "react";
import "./style.css";
import Dropdown from 'react-bootstrap/Dropdown';


export const Footer = ({
  language,
  slug
}) => {

  const translations = {
    "en": {
      "cookies": "Cookies policy",
      "cookies_url": "/en/cookies/",
      "privacy": "Privacy policy",
      "privacy_url": "/en/privacy-policy/",
      "advice": "Legal advice",
      "advice_url": "/en/privacy-policy/",
      "terms": "Terms and Conditions",
      "terms_url": "/en/terms-and-conditions/",
      "subscribe_text": "Subscribe to our newsletter",
      "cookies_footer": "We use our own and third-party cookies.",
      "cookies_more": "More info",
      "accept": "ACCEPT",
      "subscribe": "Subscribe"
    },
    "es": {
      "cookies": "Política de cookies",
      "cookies_url": "/es/cookies/",
      "privacy": "Política de privacidad",
      "privacy_url": "/es/politica-de-privacidad/",
      "advice": "Aviso legal",
      "advice_url": "/es/formas-de-pago-aceptadas/",
      "terms": "Condiciones particulares",
      "terms_url": "/es/condiciones-particulares-de-cursos-online/",
      "subscribe_text": "Suscríbete a nuestra newsletter",
      "cookies_footer": "Utilizamos cookies propias y de terceros.",
      "cookies_more": "Más info",
      "accept": "ACEPTAR",
      "subscribe": "Suscribirse"
    },
    "fr": {
      "cookies": "Confidentialité et cookies",
      "cookies_url": "/fr/cookies/",
      "privacy": "Politique de confidentialité",
      "privacy_url": "/en/privacy-policy/",
      "advice": "Avis juridique",
      "advice_url": "/en/privacy-policy/",
      "terms": "Conditions particulières",
      "terms_url": "/fr/terms-and-conditions/",
      "subscribe_text": "S'inscrire à la newsletter",
      "cookies_footer": "Nous utilisons cookies.",
      "cookies_more": "Plus d'info",
      "accept": "ACCEPTER",
      "subscribe": "S'inscrire"
    },
    "pt": {
      "cookies": "Politica de cookies",
      "cookies_url": "/pt/cookies/",
      "privacy": "Política de privacidade",
      "privacy_url": "/pt/politica-de-privacidade/",
      "advice": "Aviso legal",
      "advice_url": "/es/formas-de-pago-aceptadas/",
      "terms": "Condiciones particulares",
      "terms_url": "/pt/condiciones-particulares-de-cursos-online/",
      "subscribe_text": "Subscreva a nossa newsletter",
      "cookies_footer": "Usamos cookies.",
      "cookies_more": "Mais info",
      "accept": "ACEITAR",
      "subscribe": "Inscrever-se"
    },
    "ru": {
      "cookies": "Политика cookies",
      "cookies_url": "/en/cookies/",
      "privacy": "Политика конфиденциальности",
      "privacy_url": "/en/privacy-policy/",
      "advice": "Правовые сведения",
      "advice_url": "/en/privacy-policy/",
      "terms": "Условия и положения",
      "terms_url": "/en/terms-and-conditions/",
      "subscribe_text": "Подпишитесь на нашу рассылку",
      "cookies_footer": "Мы используем файлы cookie.",
      "cookies_more": "Подробнее",
      "accept": "ПРИНЯТЬ",
      "subscribe": "Подписаться"
    },
  };

  const subscribeFunct = (e) => {

    e.preventDefault();
    if (document.getElementById('footer_subscribe_form_email').value == '' ||
      document.getElementById('footer_subscribe_form_first_name').value == '' //||
      //document.getElementById('footer_subscribe_form_last_name').value == ''
    ) {
      alert('Please, complete all the fields.');
      return false;
    }

    document.getElementById('footer_subscribe_form_wrapper').style.display = 'none';

    let details = {
      "email": document.getElementById('footer_subscribe_form_email').value,
      "firstName": document.getElementById('footer_subscribe_form_first_name').value,
      "language": document.getElementById('footer_subscribe_form_language').value
      //"lastName": document.getElementById('footer_subscribe_form_last_name').value,
    };

    var formBody = [];
    for (var property in details) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(details[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    let options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        //"Content-Type": "application/json"
      },
      body: formBody
    };

    document.getElementById("subscribing_loading").style.display = 'block';

    fetch(document.getElementById('footer_subscribe_form').action, options)
      .then(async response => {
        document.getElementById("subscribing_loading").style.display = 'none';
        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson ? await response.json() : null;

        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;

          console.error(error);

          document.getElementById('footer_subscribe_form_error').style.display = 'block';
          document.getElementById('footer_subscribe_form_success').style.display = 'none';
          document.getElementById('footer_subscribe_form_wrapper').style.display = 'block';
          document.getElementById('footer_subscribe_form_first_name').focus();

          return Promise.reject(error);
        }

        document.getElementById('footer_subscribe_form_success').style.display = 'block';
        document.getElementById('subscribe_to_our_nl').style.display = 'none';
        document.getElementById('footer_subscribe_form_error').style.display = 'none';

      })
      .catch(error => {
        document.getElementById("subscribing_loading").style.display = 'none';
        console.info(error);
        document.getElementById('footer_subscribe_form_error').style.display = 'block';
        document.getElementById('footer_subscribe_form_success').style.display = 'none';
        document.getElementById('footer_subscribe_form_wrapper').style.display = 'block';
        document.getElementById('footer_subscribe_form_first_name').focus();
      });

    return false;

  }

  const getLanguageUrl = (lang) => {

    const url_by_lang = {

      "es": "cursos",
      "en": "tattoo-training",
      "fr": "cours",
      "pt": "cursos",
      "ru": "tattoo-training"

    };

    let new_url = `/${lang}/${url_by_lang[lang]}/${slug ? (slug + '/') : ''}`;
    return new_url;

  }

  const getCurrentLanguageName = () => {

    const lang_by_abbr = {

      "es": "español",
      "en": "English",
      "fr": "français",
      "pt": "Português",
      "ru": "Русский"

    };

    return lang_by_abbr[language];

  }


  return (
    <footer>
      <div>
        <div className="container">
          <div className="row p-2 bg-black text-white m-0">
            <div className="col col-12 col-sm-12 text-center text-sm-center my-auto text-white order-3 order-sm-3">
              <div id="footer_language_selector_menu">
                <span className="text-muted-old d-inline-block mr-2 d-none">LANGUAGE</span>
                <Dropdown>
                  <Dropdown.Toggle className="text-grey btn bg-black border-white text-muted-old sweet_sans_light px-4 py-1" id="dropdown-basic">
                    {getCurrentLanguageName()}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item className={language == "en" ? 'text_lang_selected' : ''} href={getLanguageUrl("en")}>English</Dropdown.Item>
                    <Dropdown.Item className={language == "es" ? 'text_lang_selected' : ''} href={getLanguageUrl("es")}>español</Dropdown.Item>
                    <Dropdown.Item className={language == "fr" ? 'text_lang_selected' : ''} href={getLanguageUrl("fr")}>français</Dropdown.Item>
                    <Dropdown.Item className={language == "pt" ? 'text_lang_selected' : ''} href={getLanguageUrl("pt")}>Português</Dropdown.Item>
                    <Dropdown.Item className={language == "ru" ? 'text_lang_selected' : ''} href={getLanguageUrl("ru")}>Русский</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

              </div>
              <a
                target="_blank"
                rel="noreferrer"
                href={translations[language]["cookies_url"]}
                title="Cookies policy"
                className="btn my-auto text-white p-2"
              >
                {translations[language]["cookies"]}
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={translations[language]["privacy_url"]}
                title="Privacy policy"
                className="btn my-auto text-white p-2"
              >
                {translations[language]["privacy"]}
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={translations[language]["advice_url"]}
                title="Legal advice"
                className="btn my-auto text-white p-2"
              >
                {translations[language]["advice"]}
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={translations[language]["terms_url"]}
                title="Terms and Conditions"
                className="btn my-auto text-white p-2"
              >
                {translations[language]["terms"]}
              </a>
              <span className="small text-muted-old" title="Gom ®">
                GomSystems
              </span>
            </div>
            <div className="col-sm my-auto col-12 col-sm-6 text-sm-center text-center order-1 order-sm-1">
              <a
                target="_blank"
                rel="noreferrer"
                className="p-2 text-white"
                href="https://www.instagram.com/10masters/"
                title="Instagram"
              >
                <img
                  loading="lazy"
                  src="https://cdn.10masters.com/static/icons/instagram.svg"
                  className="img-fluid hover_orange inline"
                  alt="Instagram"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                className="p-2 text-white"
                href="https://www.facebook.com/10-Masters-116755850184406"
                title="Facebook"
              >
                <img
                  loading="lazy"
                  rel="noreferrer"
                  src="https://cdn.10masters.com/static/icons/facebook.svg"
                  className="img-fluid hover_orange inline"
                  alt="Facebook"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                className="p-2 text-white"
                href="https://twitter.com/10masters_es"
                title="Twitter"
              >
                <svg alt="Twitter" viewBox="0 0 24 24" aria-hidden="true" className="img-fluid hover_orange inline" style={{color: "red", width: "26px"}}><g><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" style={{stroke: "white"}}></path></g></svg>
              </a>
            </div>
            <div className="col-md-4 col col-sm-6 my-auto order-2 order-sm-2 mt-4">
              <p id="subscribe_to_our_nl" className="sweet_sans_light text-white">
                {translations[language]["subscribe_text"]}
              </p>
              <form
                action="https://www.10masters.com/form_subscribe_activecampaign"
                method="POST"
                id="footer_subscribe_form"
                name="subscribe_form"
                className="validate"
                onSubmit={subscribeFunct}
              >
                <div id="subscribe_form_responses">
                  <div
                    className="response"
                    id="footer_subscribe_form_error"
                    style={{ display: "none" }}
                  >
                    Oops! There was a problem; check your data.
                  </div>
                  <div
                    className="response text-center my-4 text-success"
                    id="footer_subscribe_form_success"
                    style={{ display: "none" }}
                  >
                    Thank you for subscribing!
                  </div>
                </div>

                <div id="subscribing_loading" style={{ "display": "none" }} className="text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FF5A5D" className="loading_subscribe bi bi-hourglass" viewBox="0 0 16 16">
                    <path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5zm2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702c0 .7-.478 1.235-1.011 1.491A3.5 3.5 0 0 0 4.5 13v1h7v-1a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351v-.702c0-.7.478-1.235 1.011-1.491A3.5 3.5 0 0 0 11.5 3V2h-7z" />
                  </svg>
                </div>

                <div id="footer_subscribe_form_wrapper" className="mb-3">
                  <input
                    required
                    style={{
                      padding: "8px 0",
                      textIndent: "2%",
                      border: "1px solid #ABB0B2",
                      borderRadius: 3
                    }}
                    placeholder="Name"
                    type="text"
                    defaultValue=""
                    name="firstName"
                    className="required email bg-white text-dark w-100 text-left border mb-1"
                    id="footer_subscribe_form_first_name"
                  />
                  <input
                    required
                    style={{
                      padding: "8px 0",
                      textIndent: "2%",
                      border: "1px solid #ABB0B2",
                      borderRadius: 3
                    }}
                    placeholder="Email"
                    type="email"
                    defaultValue=""
                    name="email"
                    className="required email bg-white text-dark w-100 text-left border mb-1"
                    id="footer_subscribe_form_email"
                  />
                  <input id="footer_subscribe_form_language" type="hidden" name="language" value={language} />
                  <input
                    id="subscribe_btn"
                    type="submit"
                    value={translations[language]["subscribe"]}
                    name="subscribe"
                    className="btn btn-primary w-100"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </footer>

  );
};
